module.exports = __webpack_public_path__ + "static/img/preview-04.fa82cf28.webp";